export default __webpack_public_path__ + "static/media/DUBA.aa047652.png";